module.exports = "/assets/data/bd9744cad596726d05f042e936edf237-RG30.data.json";